import { HelpCircle } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, Eyebrow, SectionShell } from "./Reveal";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";

export default function FAQ() {
  const { t } = useLang();

  return (
    <SectionShell id="faq" testid="faq-section">
      <Reveal className="text-center">
        <Eyebrow>{t.faq.eyebrow}</Eyebrow>
        <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
          {t.faq.title}
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-slate-600 leading-relaxed">{t.faq.intro}</p>
      </Reveal>

      <Reveal delay={0.1} className="mx-auto mt-10 max-w-3xl">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {t.faq.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i + 1}`}
              data-testid={`faq-item-${i + 1}`}
              className="border-slate-200"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i + 1}`}
                className="font-display text-base sm:text-lg font-semibold text-slate-900 hover:no-underline"
              >
                <span className="flex items-center gap-3">
                  <HelpCircle size={18} className="shrink-0 text-sky-500" />
                  {item.q}
                </span>
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-answer-${i + 1}`}
                className="pl-9 text-sm sm:text-base text-slate-600 leading-relaxed"
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </SectionShell>
  );
}
